import { Component, Input, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ParticipantId } from 'src/app/components/participant/store/participant.model';

@Component({
  selector: 'app-projet-professionnel-contacts',
  templateUrl: './projet-professionnel-contacts.component.html',
  styleUrls: ['./projet-professionnel-contacts.component.scss'],
})
export class ProjetProfessionnelContactsComponent implements OnInit {
  @Input() item = new BehaviorSubject<any>(null);
  @Input() participant: ParticipantId | any = null;

  constructor() {}

  ngOnInit(): void {}
}
